import environment from '@environments/environment';

export const DOCUMENTS_URL = `${environment.irisApi}/document/`;

export const DOCUMENTS_V2_URL = `${environment.irisApi}/v2/document/`;
